var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentVisaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 15,
    viewBox: "0 0 45 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3035 0C26.1117 0 23.2591 1.69875 23.2591 4.83661C23.2591 8.43554 28.318 8.68409 28.318 10.4923C28.318 11.2537 27.4684 11.9351 26.0167 11.9351C23.9571 11.9351 22.4176 10.983 22.4176 10.983L21.7588 14.1499C21.7588 14.1499 23.5323 14.9543 25.8867 14.9543C29.3764 14.9543 32.1228 13.1724 32.1228 9.98044C32.1228 6.17731 27.0427 5.93615 27.0427 4.25819C27.0427 3.66176 27.7402 3.0085 29.1874 3.0085C30.8205 3.0085 32.1525 3.70103 32.1525 3.70103L32.7973 0.642633C32.7973 0.642633 31.3474 0 29.3031 0H29.3035ZM0.0998609 0.230997L0.0224609 0.692528C0.0224609 0.692528 1.36526 0.944776 2.57486 1.44835C4.13231 2.02538 4.24301 2.36171 4.50536 3.40489L7.36331 14.7159H11.1946L17.0968 0.230997H13.2745L9.48191 10.0793L7.93436 1.73109C7.79261 0.775687 7.07351 0.230535 6.19376 0.230535H0.100311L0.0998609 0.230997ZM18.634 0.230997L15.6357 14.7159H19.2807L22.2682 0.230997H18.634ZM38.9632 0.230997C38.0844 0.230997 37.6186 0.714242 37.2771 1.5583L31.9369 14.7159H35.7592L36.4986 12.5228H41.1552L41.6047 14.7159H44.9775L42.0354 0.230997H38.9632ZM39.4605 4.14454L40.5936 9.57989H37.5583L39.4609 4.14454H39.4605Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentVisaIcon);
export default __webpack_public_path__ + "static/media/payment-visa-icon.a80122d567cea4442b8bbf4eee8be47d.svg";
export { ForwardRef as ReactComponent };